export default __webpack_public_path__ + "static/media/i_bus-jeonse_bl.a62bae76.svg";